<script lang="ts">
  import EnterEmailInput from "../../common/enter-waitlist/EnterWaitlist.svelte";
  import checkMobileDevice from "../../common/is-mobile";

  const isMobile = checkMobileDevice();
  const title = "JOIN THE WAITLIST";
  const description = "Datadocs is still in development. Enter your email below to join the waitlist and receive updates on the product.";
</script>

<div class="join-waitlist-container" class:mobile={isMobile}>
  <div class="title">{title}</div>

  <div class="description">{description}</div>

  <div class="email-input-container">
    <EnterEmailInput />
  </div>
</div>

<style lang="postcss">
  .join-waitlist-container:not(mobile) {
    width: min(100% - 16px, 670px);
  }

  .title {
    @apply text-white font-bold text-center uppercase;
    letter-spacing: 0.05em;
    text-align: center;
    font-size: clamp(1.25rem, 0.75rem + 0.75vw, 1.5rem);
  }

  .mobile .title {
    font-size: 1.25rem;
  }

  .description {
    @apply text-white font-normal text-center;
    text-align: center;
    /* font-size: clamp(0.8125rem, 0.5rem + 0.5vw, 0.9375rem); */
    font-size: 15px;
    opacity: 0.8;
    width: 90%;
    margin: 8px auto 24px auto;
  }

  .mobile .description {
    font-size: 13px;
    width: 80%;
    margin-top: 12px;
    /* margin-bottom: 32px; */
  }

  .email-input-container {
    @apply relative w-full;
  }
</style>
